import { createFileRoute } from "@tanstack/react-router";

import { ReturnFormPage } from "../../../../features/purchasing/return-form-page";

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute("/_app/purchasing/returns/new")({
  validateSearch: (search: Record<string, unknown>): { goodsReceiptId?: string } =>
    typeof search["goodsReceiptId"] === "string" && uuid.test(search["goodsReceiptId"])
      ? { goodsReceiptId: search["goodsReceiptId"] }
      : {},
  component: ReturnFormRoute,
});

function ReturnFormRoute() {
  const { goodsReceiptId } = Route.useSearch();
  return <ReturnFormPage key={goodsReceiptId ?? ""} goodsReceiptId={goodsReceiptId} />;
}
